module.exports = __webpack_public_path__ + "static/media/toolbar-menu.81a30a0a.svg";